export function anonymizeAccountDetails(
  accountDetail: string,
  lengthOfFirstPart = 4,
  lengthOfLastPart = 4
): string {
  const totalLength = accountDetail.length;

  if (totalLength <= lengthOfFirstPart + lengthOfLastPart) {
    if (totalLength <= 2) {
      return '•'.repeat(totalLength);
    }

    return `${accountDetail[0]}${'•'.repeat(totalLength - 2)}${
      accountDetail[totalLength - 1]
    }`;
  }

  const firstPart = accountDetail.slice(0, lengthOfFirstPart);
  const lastPart =
    lengthOfLastPart > 0 ? accountDetail.slice(-lengthOfLastPart) : '';
  const maskedPart = '•'.repeat(
    Math.max(totalLength - lengthOfFirstPart - lengthOfLastPart, 1)
  );

  return `${firstPart}${maskedPart}${lastPart}`;
}
